import loginHistoryService from '@/api/login-history-service';

export const getDefaultLoginHistoryFilterParams = () => ({});

const state = {
  loginHistory: null,
  loginHistoryPagination: {},
  loginHistoryFilterParams: getDefaultLoginHistoryFilterParams(),
};

const getters = {};

const mutations = {
  SET_LOGIN_HISTORY(state, { data, current_page, per_page, total }) {
    state.loginHistory = data;
    state.loginHistoryPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_LOGIN_HISTORY_FILTER_PARAMS(state, params) {
    state.loginHistoryFilterParams = params;
  },
};

const actions = {
  fetchLoginHistory({ commit }, params) {
    commit('SET_LOGIN_HISTORY_FILTER_PARAMS', params);
    return loginHistoryService.getPage(params).then((res) => {
      commit('SET_LOGIN_HISTORY', res.data);
      return res.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
